/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import FilePreview from 'shared/ui/components/uploader/previews/FilePreview.vue';
import FontPreview from 'shared/ui/components/uploader/previews/FontPreview.vue';
import ImagePreview from 'shared/ui/components/uploader/previews/ImagePreview.vue';

const __vue_script__ = {
    name: 'AssetPreview',

    components: {
        FilePreview,
        FontPreview,
        ImagePreview
    },

    props: {
        item: {
            type: Object,
            default: () => ({})
        },

        asset: {
            type: Object,
            default: () => ({})
        },

        event: {
            type: Object,
            required: true
        },

        small: {
            type: Boolean,
            default: false
        },

        cell: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        assetValue() {
            return this.item.hasOwnProperty(this.cell?.field) ? this.item[this.cell.field] : undefined;
        },

        localAsset() {
            return this.assetValue ? this.$utils.assets.getEventAssetPath(this.event._id, this.assetValue) : undefined;
        },

        innerItem() {
            return Object.keys(this.asset).length ? this.asset : this.item;
        },
    },

    methods: {
        getComponentForAttachment(attachment) {
            const mime = attachment.content_type;
            const previews = [ImagePreview, FontPreview];
            for (const p of previews) {
                if (p.supports.includes(mime)) {
                    return p;
                }
            }

            return FilePreview;
        },

        attachment(asset, name) {
            return this.$utils.attachments.getAttachmentMetadata(asset, name);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attachments-preview"},[(_vm.localAsset)?[_c('image-preview',{attrs:{"src":_vm.localAsset,"name":_vm.localAsset,"attachment":{},"doc-id":_vm.innerItem._id,"event":_vm.event,"small":_vm.small}})]:_vm._l((_vm.$utils.attachments.getAttachmentNames(_vm.innerItem)),function(name){return _c(_vm.getComponentForAttachment(_vm.attachment(_vm.innerItem, name)),{tag:"component",attrs:{"attachment":_vm.attachment(_vm.innerItem, name),"name":name,"doc-id":_vm.innerItem._id,"event":_vm.event,"small":_vm.small}})})],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AssetPreview.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__